import { action, computed, observable } from 'mobx'
import { createViewModel } from 'mobx-utils'
import { JtechStore } from 'src/plugins/mobx'
export default class AnalyzeInvoiceSettlementModel {
    @observable searchParams = {};

    static getInstance () {
      return JtechStore.getSingleton('AnalyzeInvoiceSettlementModel', new AnalyzeInvoiceSettlementModel())
    }

    @action.bound setSearchParams (searchParams) {
      this.searchParams = { ...searchParams }
    }
}
